import React from 'react';
import PropTypes from 'prop-types';

import Placeholder from 'components/consumer/Placeholder';
import CtaButton from 'components/essentials/Cta/CtaButton';
import PDPDetailsAndProductCareLink from '../PDPDetailsAndProductCareLink';

const PDPProductDescriptionUI = ({
  loading,
  buttonText,
  description,
  headline,
  onButtonClick,
}) => {
  if (loading) {
    return (
      <div className="border-t border-solid border-gray-light6 mt-14 pt-14">
        <Placeholder
          loading
          type="rect"
          className="text-xl font-bold text-gray mb-4 PDPProductDescriptionUI__headline--loading"
          style={{ height: '64px' }}
        />

        <Placeholder
          loading
          type="rect"
          className="text-sm text-gray m-0 PDPProductDescriptionUI__description--loading"
          style={{ height: '121px' }}
        />

        <Placeholder
          loading
          type="rect"
          style={{ height: '39px', width: '235px', marginTop: '20px' }}
        />

        <Placeholder
          type="rect"
          loading
          style={{ height: '26px', width: '174px', marginTop: '1.5rem' }}
        />
      </div>
    );
  }

  return headline || description ? (
    <div className="border-t border-solid border-gray-light6 mt-14 pt-14">
      {headline && description ? (
        <>
          <h2 className="text-xl font-bold text-gray mb-4">{headline}</h2>
          <p className="text-sm text-gray m-0">{description}</p>
        </>
      ) : (
        <h2 className="text-sm text-gray m-0">{headline || description}</h2>
      )}

      <div className="mt-6">
        <PDPDetailsAndProductCareLink />
      </div>

      {!!buttonText && !!onButtonClick && (
        <CtaButton
          styling="solid-button"
          color="brand"
          size="sm"
          spacing="sm"
          onClick={onButtonClick}
          className="mt-4"
        >
          {buttonText}
        </CtaButton>
      )}
    </div>
  ) : (
    <div className="PDPProductDescriptionUI__filler" />
  );
};

PDPProductDescriptionUI.propTypes = {
  buttonText: PropTypes.string,
  description: PropTypes.string,
  headline: PropTypes.string,
  onButtonClick: PropTypes.func,
  loading: PropTypes.bool,
};

export default PDPProductDescriptionUI;
